export const GA_TRACKING_ID = "G-NVB32Y0ZDP";
export const AW_TRACKING_ID = "AW-10896902454";

// https://developers.google.com/analytics/devguides/collection/gtagjs/pages
export const pageview = url => {
  window.gtag("config", GA_TRACKING_ID, {
    page_path: url,
  });
  window.gtag("config", AW_TRACKING_ID);
};

// https://developers.google.com/analytics/devguides/collection/gtagjs/events
export const event = ({ action, category, label, value }) => {
  window.gtag("event", action, {
    event_category: category,
    event_label: label,
    value: value,
  });
};

export const consent = consent => {
  window.gtag("consent", "update", consent);
};
